import { useState } from "react";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useCompany } from "@/context/CompanyContext";
import { Button } from "@/components/ui/button";

export function CompanySuggestion({ file, onDone, compact = false }) {
  const { companies } = useCompany();
  const [busy, setBusy] = useState(false);
  const sug = file.company_ai;
  if (!sug || sug.status !== "suggested" || !["edit", "owner", undefined].includes(file.access)) return null;
  const target = companies.find((c) => c.id === sug.company_id);
  if (!target) return null;
  const run = async (action) => {
    setBusy(true);
    try {
      await api.post(`/ai/files/${file.id}/company/${action}`);
      toast.success(action === "accept" ? `Document déplacé dans ${target.name}` : "Suggestion ignorée");
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className={`border border-amber-200 bg-amber-50 rounded-lg ${compact ? "p-3" : "p-3 mx-4 mt-3"} text-sm`} data-testid={`company-suggestion-${file.id}`}>
      <div className="flex items-start gap-2">
        <Building2 className="h-4 w-4 text-amber-700 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          {!compact && <div className="font-medium text-amber-900">Société à vérifier</div>}
          <div className="text-amber-900">L'IA pense que ce document appartient à <b>{target.name}</b> ({Math.round((sug.confidence || 0) * 100)} %).</div>
          {sug.reason && <div className="text-xs text-amber-800 mt-0.5">{sug.reason}</div>}
        </div>
      </div>
      <div className="flex gap-2 mt-2 justify-end">
        <Button size="sm" variant="outline" disabled={busy} onClick={() => run("dismiss")} data-testid={`company-suggestion-dismiss-${file.id}`}>Ignorer</Button>
        <Button size="sm" disabled={busy} onClick={() => run("accept")} data-testid={`company-suggestion-accept-${file.id}`}>Déplacer dans {target.name}</Button>
      </div>
    </div>
  );
}
